export default {
  url: 'URL',
  ptDbId: 'ID bazy danych PT',
};
